import { AnimatePresence, motion } from 'framer-motion';
import styles from './Winners.module.css';
import hum from '../../assets/images/hum.jpg';
import { iconsSources } from '../../helpers/icons';
import star from '../../assets/images/star.png';
import { hideNumber } from '../../helpers/titreHelper';

export const Winners = ({ messages }) => {
  const messagesCurrent = messages
    .filter((msg) => msg.titrTag === 'F2')
    .slice(-3)
    .map((el) => el.message);

  const onErrorHandler = (e, message) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };
  const avatar = (message) => {
    return message?.image && message?.image !== '1'
      ? message?.image
      : iconsSources[message?.channel];
  };

  const coef = 0.5;

  return (
    <div className={styles.wrapper}>
      {messagesCurrent.map((msg, i) => (
        <div className={styles.item} key={msg.id}>
          <div className={styles.avatarBlock}>
            <AnimatePresence mode="wait">
              <motion.img
                key={msg.id}
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.1, 1] }}
                transition={{
                  duration: 0.7,
                  delay: 0.5 + i * coef + 0.5,
                  times: [0, 0.7, 1],
                }}
                exit={{
                  scale: 0,
                  transition: { duration: 0.4, delay: 0 },
                }}
                src={avatar(msg)}
                alt={msg?.author}
                onError={(e) => onErrorHandler(e, msg)}
              />
            </AnimatePresence>
            <div className={styles.star}>
              <motion.img
                initial={{ scale: 0, rotate: '60deg' }}
                animate={{ scale: 1, rotate: '0' }}
                transition={{ duration: 1, delay: i * coef + 0.5 }}
                src={star}
                alt="star"
              />
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.5 + i * coef + 0.5 }}
            className={styles.name}>
            {msg?.author || hideNumber(msg?.senderNumber)}
          </motion.div>
        </div>
      ))}
    </div>
  );
};
